// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slot-games-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.slot-games-section .slot-games-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.slot-games-section .slot-games-wrap .slot-games-box .para-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}
.slot-games-section .slot-games-wrap .slot-games-box .games-grid-box {
  --grid-column-number: 4;
  --grid-gap: 2rem;
  display: grid;
  grid-template-columns: repeat(var(--grid-column-number), 1fr);
  gap: var(--grid-gap);
  margin: 4rem 0;
}
.slot-games-section .slot-games-wrap .slot-games-box .btn-box {
  display: flex;
  justify-content: center;
  margin-top: 4rem;
}
.slot-games-section .slot-games-wrap .filters-grid-box {
  --grid-column-number: 4;
  --grid-gap: 2rem;
  display: grid;
  grid-template-columns: repeat(var(--grid-column-number), 1fr);
  column-gap: var(--grid-gap);
}
.slot-games-section .slot-games-wrap .filters-grid-box .games-filter-section {
  display: inline-block;
  grid-column-start: 1;
  grid-column-end: 4;
}
@media screen and (max-width: 991.98px) {
  .slot-games-section {
    padding: 2.5rem 0;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .para-text {
    font-size: 1rem;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .games-grid-box {
    --grid-column-number: 4;
    --grid-gap: 1rem;
    margin: 2.5rem 0;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .btn-box {
    margin-top: 2.5rem;
  }
  .slot-games-section .slot-games-wrap .filters-grid-box {
    --grid-column-number: 4;
    --grid-gap: 1rem;
  }
  .slot-games-section .slot-games-wrap .filters-grid-box .games-filter-section {
    grid-column-start: 1;
    grid-column-end: 4;
  }
}
@media screen and (max-width: 767.98px) {
  .slot-games-section {
    padding: 2rem 0;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .para-text {
    font-size: 0.875rem;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .games-grid-box {
    --grid-column-number: 2;
    --grid-gap: 1rem;
    margin: 2rem 0;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .btn-box {
    margin-top: 1.25rem;
  }
  .slot-games-section .slot-games-wrap .filters-grid-box {
    --grid-column-number: 3;
    --grid-gap: 1rem;
  }
  .slot-games-section .slot-games-wrap .filters-grid-box .games-filter-section {
    grid-column-start: 1;
    grid-column-end: 3;
  }
}
@media screen and (max-width: 639.98px) {
  .slot-games-section {
    padding: 2rem 0;
  }
  .slot-games-section .slot-games-wrap .slot-games-box .games-grid-box {
    --grid-column-number: 2;
  }
  .slot-games-section .slot-games-wrap .filters-grid-box {
    --grid-column-number: 1;
    --grid-gap: 1rem;
    column-gap: 0;
    row-gap: var(--grid-gap);
  }
  .slot-games-section .slot-games-wrap .filters-grid-box .games-filter-section {
    grid-column-start: 1;
    grid-column-end: 3;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AllSlotGamesSection/AllSlotGamesStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AAEM;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAAR;AAGM;EACE,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,6DAAA;EACA,oBAAA;EACA,cAAA;AADR;AAIM;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAFR;AAMI;EACE,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,6DAAA;EACA,2BAAA;AAJN;AAMM;EACE,qBAAA;EACA,oBAAA;EACA,kBAAA;AAJR;AASE;EAhDF;IAiDI,iBAAA;EANF;EAUM;IACE,eAAA;EARR;EAWM;IACE,uBAAA;IACA,gBAAA;IACA,gBAAA;EATR;EAYM;IACE,kBAAA;EAVR;EAcI;IACE,uBAAA;IACA,gBAAA;EAZN;EAcM;IACE,oBAAA;IACA,kBAAA;EAZR;AACF;AAiBE;EAhFF;IAiFI,eAAA;EAdF;EAkBM;IACE,mBAAA;EAhBR;EAmBM;IACE,uBAAA;IACA,gBAAA;IACA,cAAA;EAjBR;EAoBM;IACE,mBAAA;EAlBR;EAsBI;IACE,uBAAA;IACA,gBAAA;EApBN;EAsBM;IACE,oBAAA;IACA,kBAAA;EApBR;AACF;AAyBE;EAhHF;IAiHI,eAAA;EAtBF;EA0BM;IACE,uBAAA;EAxBR;EA4BI;IACE,uBAAA;IACA,gBAAA;IACA,aAAA;IACA,wBAAA;EA1BN;EA4BM;IACE,oBAAA;IACA,kBAAA;EA1BR;AACF","sourcesContent":[".slot-games-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .slot-games-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .slot-games-box {\n      .para-text {\n        color: var(--black-1000);\n        font-size: 1.5rem;\n        font-weight: 400;\n        line-height: 1.4;\n      }\n\n      .games-grid-box {\n        --grid-column-number: 4;\n        --grid-gap: 2rem;\n        display: grid;\n        grid-template-columns: repeat(var(--grid-column-number), 1fr);\n        gap: var(--grid-gap);\n        margin: 4rem 0;\n      }\n\n      .btn-box {\n        display: flex;\n        justify-content: center;\n        margin-top: 4rem;\n      }\n    }\n\n    .filters-grid-box {\n      --grid-column-number: 4;\n      --grid-gap: 2rem;\n      display: grid;\n      grid-template-columns: repeat(var(--grid-column-number), 1fr);\n      column-gap: var(--grid-gap);\n\n      .games-filter-section {\n        display: inline-block;\n        grid-column-start: 1;\n        grid-column-end: 4;\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .slot-games-wrap {  \n      .slot-games-box {\n        .para-text {\n          font-size: 1rem;\n        }\n\n        .games-grid-box {\n          --grid-column-number: 4;\n          --grid-gap: 1rem;\n          margin: 2.5rem 0;\n        }\n  \n        .btn-box {\n          margin-top: 2.5rem;\n        }\n      }\n\n      .filters-grid-box {\n        --grid-column-number: 4;\n        --grid-gap: 1rem;\n\n        .games-filter-section {\n          grid-column-start: 1;\n          grid-column-end: 4;\n        }\n      }\n    }\n  }\n  \n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .slot-games-wrap {  \n      .slot-games-box {\n        .para-text {\n          font-size: 0.875rem;\n        }\n\n        .games-grid-box {\n          --grid-column-number: 2;\n          --grid-gap: 1rem;\n          margin: 2rem 0;\n        }\n  \n        .btn-box {\n          margin-top: 1.25rem;\n        }\n      }\n\n      .filters-grid-box {\n        --grid-column-number: 3;\n        --grid-gap: 1rem;\n\n        .games-filter-section {\n          grid-column-start: 1;\n          grid-column-end: 3;\n        }\n      }\n    }\n  }\n  \n  @media screen and (max-width: 639.98px) {\n    padding: 2rem 0;\n\n    .slot-games-wrap {  \n      .slot-games-box {\n        .games-grid-box {\n          --grid-column-number: 2;\n        }\n      }\n\n      .filters-grid-box {\n        --grid-column-number: 1;\n        --grid-gap: 1rem;\n        column-gap: 0;\n        row-gap: var(--grid-gap);\n\n        .games-filter-section {\n          grid-column-start: 1;\n          grid-column-end: 3;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
